<template>
  <div class="model">
    <img src="../assets/banner.png" alt="" class="banner" />
    <div class="model-content">
      <div class="title">{{ appName }}</div>
      <div class="ma">
        <canvas id="qrCanvas" width="100" height="100" style="t"></canvas>
        <div class="logo">
          <img src="../assets/logo.png" alt="" />
        </div>
      </div>
    </div>
    <div class="join" @click="gotoUrl" v-if="isTrueASD">去办理</div>
    <template v-else>
      <div>
        <div class="join" @click="join" v-if="clickType">去办理</div>
        <div class="join" style="opacity: 0.5" v-else>
          <img src="../assets/loading.png" alt="" />去办理
        </div>
      </div>
    </template>

    <div class="downLoad" @click="download" v-if="!isTrueASD">下载爱山东</div>
    <div class="bottom_img">
      <img src="../assets/icon1.png" alt="" />
    </div>
    <div
      v-show="searchShow"
      style="
        display: none;
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 999;
        top: 0;
        left: 0;
        color: #fff;
      "
      id="ssss"
      @click="hide()"
    >
      <img src="../../src/assets/s2.png" width="100%" border="0" />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Toast } from "vant";
import layer from "vue-layer";
Vue.prototype.$layer = layer(Vue);

Vue.use(Toast);

export default {
  name: "home",
  data() {
    return {
      searchShow: false, //弹窗提示
      // locationUrl: "",
      appName: "", //应用名字
      appUrl: "", //应用地址
      isTrueASD: false, //是否是asd
      clickType: true,
    };
  },
  mounted() {
    this.openWithAsd();
    this.appName = this.getParameter("appName") || "爱山东";
    this.appUrl = this.getParameter("appUrl") || "";
    var qr = new QRCode(document.getElementById("qrCanvas"), {
      text: window.location.href,
      width: 100,
      height: 100,
      colorDark: "#000000",
      colorLight: "#ffffff",
      correctLevel: 1,
    });

    // 获取生成的二维码图片数据
    var imageData = qr._el.firstChild.toDataURL();

    // 绘制渐变色背景
    var canvas = document.getElementById("qrCanvas");
    var ctx = canvas.getContext("2d");
    // 将二维码图像绘制在上面
    var img = new Image();
    img.onload = function () {
      ctx.drawImage(img, 0, 0);
    };
    img.src = imageData;
  },
  created() {},
  methods: {
    hide() {
      this.searchShow = !this.searchShow;
    },
    openWithAsd() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf("asd") > -1||ua.indexOf("hanweb-harmony") > -1) {
        //是爱山东
        this.isTrueASD = true;
      } else {
        //不是
        this.isTrueASD = false;
      }
    },
    async download() {
      // console.log(navigator.userAgent);
      // return;
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        // ios下载地址
        window.location.href =
          "https://itunes.apple.com/cn/app/爱山东-政务服务/id1064793304?mt=8";
      } else if (
        navigator.userAgent.match(/android/i) &&
        !navigator.userAgent.match(/harmonyos|harmony/i)
      ) {
        // android下载地址
        window.location.href =
          "https://isdapp.shandong.gov.cn/jmportal/asd2wm/pack/asd.apk";
      } else if (navigator.userAgent.match(/harmonyos|harmony/i)) {
        window.location.href =
          "https://appgallery.huawei.com/app/detail?id=com.hanweb.hongmeng.asd.activity";
      }
    },
    async join() {
      var ua = window.navigator.userAgent;
      var qq = ua.indexOf("QQ") >= 0 && ua.indexOf("MQQBrowser") == -1;
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        // iOS端
        qq = ua.indexOf("QQ") >= 0 && ua.indexOf("MQQBrowser") == -1;
      } else if (navigator.userAgent.match(/android/i)) {
        qq = ua.indexOf("QQ") >= 0 && ua.indexOf("QQTheme") > -1;
      }
      if (
        (ua && ua.indexOf("MicroMessenger") >= 0) ||
        ua.indexOf("Weibo") >= 0 ||
        qq ||
        ua.indexOf("alipayclient") >= 0
      ) {
        this.searchShow = true;
      } else {
        this.clickType = false;
        let that = this;
        if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
          // iOS端的跳转地址
          window.location.href = `asdscheme://sdzwfw/openapp?goto={'path':'webview','title':'爱山东','url':'${this.appUrl}'}`;
          window.setTimeout(function () {
            window.location.href =
              "https://itunes.apple.com/cn/app/爱山东-政务服务/id1064793304?mt=8";
            that.clickType = true;
          }, 3000);
        } else if (
          navigator.userAgent.match(/android/i) &&
          !navigator.userAgent.match(/harmonyos|harmony/i)
        ) {
          //安卓端的跳转地址
          window.location.href = `asdscheme://sdzwfw/openapp?goto={'path':'webview','title':'爱山东','url':'${this.appUrl}'}`;
          window.setTimeout(function () {
            window.location.href =
              "https://isdapp.shandong.gov.cn/jmportal/asd2wm/pack/asd.apk";
            that.clickType = true;
          }, 3000);
        } else if (navigator.userAgent.match(/harmonyos|harmony/i)) {
          //鸿蒙端的跳转地址
          window.location.href = `asdscheme://sdzwfw/openapp?goto={"path":"webview","title":"爱山东","url":"${this.appUrl}"}`;
          window.setTimeout(function () {
            window.location.href =
              "https://appgallery.huawei.com/app/detail?id=com.hanweb.hongmeng.asd.activity";
            that.clickType = true;
          }, 3000);
        }
      }
    },
    gotoUrl() {
      window.location.href = this.appUrl;
    },
    getParam: function () {
      var url = location.search; //获取url中"?"符后的字串
      if (url.indexOf("?") != -1) {
        //判断是否有参数
        var str = url.substr(1); //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
        strs = str.split("="); //用等号进行分隔 （因为知道只有一个参数 所以直接用等号进分隔 如果有多个参数 要用&号分隔 再用等号进行分隔）
        return strs[1];
      }
    },
    getParameter(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      let currentStr = r[2];
      if (currentStr.indexOf("%20") > 0) {
        currentStr = currentStr.replace(/%20/g, "+");
      }
      if (r != null) return decodeURIComponent(currentStr);
      return null;
    },
  },
};
</script>

<style scoped>
.model {
  width: 100%;
  background-size: cover;
  position: relative;
  min-height: 100vh;
  background-color: #fff;
}
.banner {
  width: 100%;
  height: auto;
  margin-bottom: 34px;
}
.model-content {
  position: absolute;
  top: 45px;
  left: 74px;
  right: 74px;
}
.title {
  color: #ffffff;
  line-height: 36px;
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 72px;
}
.ma {
  width: 112px;
  height: 112px;
  margin: 0 auto;
  background-color: #fff;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}
.ma .logo {
  position: absolute;
  width: 24px;
  height: 24px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}
.ma .logo img {
  width: 80%;
  height: 80%;
}
.join {
  width: calc(100% - 24px);
  height: 44px;
  background: #3388ff;
  border-radius: 25px;
  margin: 0 auto;
  color: #ffffff;
  font-size: 18px;
  /* line-height: 44px; */
  text-align: center;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.join img {
  margin-right: 5px;
  animation: spin 2s linear infinite; /* 应用动画 */
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.downLoad {
  width: calc(100% - 24px);
  height: 44px;
  border: 1px solid #3388ff;
  border-radius: 25px;
  margin: 0 auto;
  color: #3388ff;
  font-size: 18px;
  line-height: 44px;
  text-align: center;
  margin-bottom: 27px;
}
.bottom_img {
  width: 83px;
  height: 28px;
  margin: 0 auto;
}
.bottom_img img {
  display: block;
  width: 100%;
}

.user {
  /* margin-bottom: 30px; */
  position: absolute;
  bottom: 50px;
  width: 100%;
  text-align: center;
  align-content: center;
  justify-content: center;
  text-align: center;
  color: white;
  vertical-align: middle;
}

.head {
  width: 43px;
  height: 43px;
  vertical-align: middle;
}
/* .midImg{
  display: block;
  max-width: 65%;
  height: auto;
  margin: 0 auto;
} */
.name {
  margin: 0 auto;
  vertical-align: middle;
  bottom: 1px;
  justify-content: center;
  font-size: 30px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  /* color: #333333; */
  /* line-height: 50px; */
}

.description {
  font-size: 26px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: center;
  /* color: #333333; */
  line-height: 32px;
  margin: 15px;
}

.bottom-zz {
  display: flex;
  align-items: flex-start;
  margin-left: 160px;
  font-size: 12px;
}
.bottom-zz span {
  padding: 2px 12px;
  border-radius: 8px;
  background-color: #2292f5;
  margin-bottom: 10px;
  margin-right: 10px;
}
.bottom-zz p {
  text-align: left;
}
</style>
